// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1l1bO","buttons":"Footer_buttons__14Ox0"};